import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MPaymentTransactionEntity } from './m-payment-transaction.entity';
import { OrderEntity } from './order.entity';

@Index(
	'm_sm_payment_externalId_deleted_userId',
	['deletedUserId', 'mSmPaymentExternalId'],
	{},
)
@Index(
	'm_sm_payment_fk_m_payment_transaction__id',
	['mSmPaymentFkMPaymentTransactionId'],
	{},
)
@Index('m_sm_payment_fk_order__id', ['mSmPaymentFkOrderId'], {})
@Entity(
	'm_sm_payment_transaction_order',
	{},
	{ label: 'Payment Transaction Order' },
)
export class MSmPaymentTransactionOrderEntity extends BaseEntity {
	@Column('varchar', {
		name: 'm_sm_payment_externalId',
		nullable: true,
		length: 64,
	})
	public mSmPaymentExternalId!: string | null;

	@Column('int', {
		name: 'm_sm_payment_fk_m_payment_transaction__id',
		unsigned: true,
	})
	public mSmPaymentFkMPaymentTransactionId!: number;

	@Column('int', { name: 'm_sm_payment_fk_order__id', unsigned: true })
	public mSmPaymentFkOrderId!: number;

	@Column('decimal', { name: 'm_sm_payment_amount', precision: 13, scale: 2 })
	public mSmPaymentAmount!: string;

	@ManyToOne(
		() => MPaymentTransactionEntity,
		(mPaymentTransaction) => mPaymentTransaction.mSmPaymentTransactionOrders,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{
			name: 'm_sm_payment_fk_m_payment_transaction__id',
			referencedColumnName: 'id',
		},
	])
	public mSmPaymentFkMPaymentTransaction!: MPaymentTransactionEntity;

	@ManyToOne(() => OrderEntity, (order) => order.mSmPaymentTransactionOrders, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([
		{ name: 'm_sm_payment_fk_order__id', referencedColumnName: 'id' },
	])
	public mSmPaymentFkOrder!: OrderEntity;
}
